import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '~/services/api';

/**
 * Botão "Baixar etiqueta" da entrega (ida) pelos Correios, no mesmo formato
 * do botão do card de devolução. Autocontido: usa a rota de download que já
 * existe e funciona em qualquer tela que tenha o carrinho.
 */

export const hasCorreiosLabel = cart =>
  Boolean(
    cart?.is_for_delivery &&
      cart?.delivery_method === 'CORREIOS' &&
      cart?.delivery?.id_on_service &&
      cart?.delivery?.track_data
  );

export default function CorreiosLabelDownloadButton({ cart }) {
  const [isDownloading, setIsDownloading] = useState(false);

  if (!hasCorreiosLabel(cart)) return null;

  const handleDownload = async () => {
    try {
      setIsDownloading(true);

      const response = await api.get(
        `/correios/prepostagem/${cart.id}/rotulo/download`,
        { responseType: 'blob' }
      );

      // 202 = rótulo ainda em processamento (o corpo não é o PDF)
      if (response.status === 202) {
        toast.info('A etiqueta ainda está sendo gerada. Aguarde...');
        return;
      }

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `etiqueta-correios-${
        cart?.order_number || cart?.id || 'pedido'
      }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('Erro ao baixar a etiqueta.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className="btn btn-outline-primary"
      onClick={handleDownload}
      disabled={isDownloading}
    >
      <i
        className={`fas ${
          isDownloading ? 'fa-spinner fa-spin' : 'fa-download'
        } mr-2`}
      />
      Baixar etiqueta
    </button>
  );
}
